import { io } from "socket.io-client";

import { AppDispatch } from "@/store";
import {
  setServerConnection,
  setServerConnectionEstablishing,
  setStandConnectionStatus,
  StandConnectionStatus,
} from "@/store/reducers/serverConnection/serverSlice";
import { getAuthToken } from "@/utils/tokenHelpers";

export let serverSocket = io(process.env.REACT_APP_SERVER_URL + "/client", {
  autoConnect: false,
});

export const initServerSocketConnection = () => (dispatch: AppDispatch) => {
  try {
    serverSocket = io(process.env.REACT_APP_SERVER_URL + "/client", {
      auth: { token: getAuthToken() },
    });
    serverSocket.on("connect", () => {
      dispatch(setServerConnection(serverSocket.connected));
      dispatch(setServerConnectionEstablishing(false));
      serverSocket.off("disconnect");
      serverSocket.on("disconnect", () => {
        dispatch(setServerConnection(serverSocket.connected));
      });
    });
  } catch (e: any) {}
};

export const closeServerSocketConnection = () => (dispatch: AppDispatch) => {
  try {
    if (serverSocket.connected) {
      serverSocket.close();
      serverSocket.disconnect();
      dispatch(setServerConnection(serverSocket.connected));
    }
  } catch (e: any) {}
};

export const standConnectionListener = () => (dispatch: AppDispatch) => {
  try {
    serverSocket.off("SERVER:stand_connection");
    serverSocket.on(
      "SERVER:stand_connection",
      ({ data: connectionStatus }: { data: StandConnectionStatus }) => {
        dispatch(setStandConnectionStatus(connectionStatus));
      }
    );
  } catch (e) {}
};
